import { render } from "./ExcelIcon.vue?vue&type=template&id=44351422"
const script = {}
script.render = render

export default script